import limitService from "../../services/siteService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new limitService();

export const getSiteList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_SITE,
      payload: { ...initialState, loading: true },
    });
    service
      .getSiteData(data)
      .then((res) => {
        dispatch({
          type: types.GET_SITE,
          payload: { data: res.data.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_SITE, //todo change wih api status
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit data",
            loading: false,
            next: false,
          },
        });
      });
  };
};

export const AddSite = (data, obj) => {
  return (dispatch) => {
     dispatch({
       type: types.ADD_SITE,
       payload: { ...initialState, loading: true },
     });
     return service
       .addSite(data, obj)
       .then((res) => {
         dispatch({
           type: types.ADD_SITE,
           payload: {
             data: res.data.data,
             message: res.data.message,
             status: 200,
             loading: false,
           },
         });
         return res;
       })
       .catch((error) => {
         dispatch({
           type: types.ADD_SITE,
           payload: {
             ...initialState,
             message: error?.response?.data?.error,
             loading: false,
             status: error.response?.status || 500,
           },
         });
         throw error
       });
   };
};

export const DeleteSite = (data) => {
    return (dispatch) => {
      dispatch({
        type: types.DELETE_SITE,
        payload: { ...initialState, loader: true },
      });
      return service
        .deleteSite(data)
        .then((res) => {
          dispatch({
            type: types.DELETE_SITE,
            payload: {
              data: res.data.data,
              message: res.data.message,
              status: 200,
              loading: false,
            },
          });
          return res;
        })
  
        .catch((error) => {
          dispatch({
            type: types.DELETE_SITE,
            payload: {
              ...initialState,
              message: error?.response?.data?.error,
              loading: false,
              status: error.response?.status || 500,
            },
          });
           throw error
        });
    };
};

export const ApproveSite = (data) => {
    return (dispatch) => {
      dispatch({
        type: types.APPROVE_SITE,
        payload: { ...initialState, loading: true },
      });
      return service
        .approveSite(data)
        .then((res) => {
          dispatch({
            type: types.APPROVE_SITE,
            payload: {
              data: res.data.data,
              message: res.data.message,
              status: 200,
              loading: false,
            },
          });
          return res;
        })
  
        .catch((error) => {
          dispatch({
            type: types.APPROVE_SITE,
            payload: {
              ...initialState,
              message: error?.response?.data?.error,
              loading: false,
              status: error.response?.status || 500,
            },
          });
           throw error
        });
    };
};


export const UpdateSite = (params, payload) => {
 return (dispatch) => {
     dispatch({
       type: types.UPDATE_SITE,
       payload: { ...initialState, loading: true },
     });
    return service
       .updateSite( params, payload)
       .then((res) => {
         dispatch({
           type: types.UPDATE_SITE,
           payload: {
             data: res.data.data,
             message: res.data.message,
             status: 200,
             loading: false,
           },
         });
         return res
       })
       .catch((error) => {
         dispatch({
           type: types.UPDATE_SITE,
           payload: {
             ...initialState,
             message: error?.response?.data?.error,
             loading: false,
             status: error.response?.status || 500,
           },
         });
         throw error;
       });
   };
};